import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBooster} from "../../types/booster_generic/IPromotionBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {findPromotionByType} from "../../utils/promotions/find_promotion_by_type";
import {isPromotionAvailable} from "../../utils/promotions/is_promotion_available";

export const promotionOpenDaysBooster: IPromotionBooster = {
    category: IBoosterCategory.Promotion,
    type: PromotionType.OPEN_DAYS,

    isValid(params) {
        return isPromotionAvailable(params.promotions, PromotionType.OPEN_DAYS);
    },

    getSegments(params) {
        const date = findPromotionByType(params.promotions, PromotionType.OPEN_DAYS)?.promotion_date_range?.lower;

        if (!date) {
            return null;
        }

        return [
            "Drzwi otwarte odbędą się",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: date
            }
        ];
    }
};
import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBooster} from "../../types/booster_generic/IPromotionBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {findPromotionByType} from "../../utils/promotions/find_promotion_by_type";
import {isPromotionAvailable} from "../../utils/promotions/is_promotion_available";

export const promotionOpenDaysBooster: IPromotionBooster = {
    category: IBoosterCategory.Promotion,
    type: PromotionType.OPEN_DAYS,

    isValid(params) {
        return isPromotionAvailable(params.promotions, PromotionType.OPEN_DAYS);
    },

    getSegments(params) {
        const date = findPromotionByType(params.promotions, PromotionType.OPEN_DAYS)?.promotion_date_range?.lower;

        if (!date) {
            return null;
        }

        return [
            "Drzwi otwarte odbędą się",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: date
            }
        ];
    }
};
